import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import { smoothScroll } from "../../../../utils/scroll";
import PropTypes from 'prop-types';
import moneyFormatter from "money-formatter";


const ValueStatement = ({ campaignData }) => {
  return (
    <div id="value-statement" className="value-statement background-section d-flex">
      <div className="text-left statement-text-left">
        <h1 className="headline-font">Barclays Personal Loan<br/>
          <span className="text-muted font-weight-light smaller-headline">Flexible, affordable loans up to {moneyFormatter.format('USD', campaignData.maxLoanAmount, 0)}.</span>
        </h1>
        <p className="h4 text-barclays-secondary-dark-blue font-weight-light statement">
          <i className="material-icons text-barclays-primary check-icon statement-check-icon" aria-hidden="true">check</i>Rates
          starting as low as {campaignData.minApr}% APR
          <sup className="h6 superscript">
            <Link to="#apr-foot-note" scroll={smoothScroll}>1</Link>
          </sup>
        </p>
        <p className="h4 text-barclays-secondary-dark-blue font-weight-light text-nowrap statement">
          <i className="material-icons text-barclays-primary check-icon statement-check-icon" aria-hidden="true">check</i>Loan
          terms of 36, 48 or 60 months</p>
        <p className="h4 text-barclays-secondary-dark-blue font-weight-bold statement">
          <i className="material-icons text-barclays-primary check-icon statement-check-icon" aria-hidden="true">check</i>Absolutely
          NO fees
        </p>
      </div>
    </div>
  );
};

ValueStatement.propTypes = {
  campaignData: PropTypes.shape({
    maxLoanAmount: PropTypes.string.isRequired,
    minApr: PropTypes.string.isRequired
  }).isRequired
};

export default ValueStatement;
